export default "__VITE_ASSET__b0b5dfc5__"